import {SmartPrediction} from '../models/smart-prediction.entity';

export class SmartPredictionsResponse {
  totalPredictions = 0;
  predictions: SmartPrediction[] = [];

  constructor(rawData: any[], totalPredictions: number) {
    this.totalPredictions = totalPredictions;
    this.predictions = rawData.map(raw => {
      const newPrediction = new SmartPrediction();

      newPrediction.deserialize(raw);
      return newPrediction;
    });
  }
}
